import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=197bc023&scoped=true&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=197bc023&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bc023",
  null
  
)

export default component.exports